<template>
  <div class="check">
    <div class="nav">
      <p
        v-for="item in navList"
        :key="item.id"
        :class="item.id === current ? 'active' : 'none'"
        @click="navClick(item.id)"
      >
        {{ item.title }}
      </p>
    </div>
    <div class="check-detail">
      <company-info v-if="current === 1"></company-info>
      <financial-products v-else-if="current === 2"></financial-products>
      <financial-demand v-else-if="current === 3"></financial-demand>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import CompanyInfo from './components/companyInfo.vue';
import FinancialDemand from './components/financialDemand.vue';
import FinancialProducts from './components/financialProducts.vue';

export default {
	components: {
    CompanyInfo,
    FinancialProducts,
    FinancialDemand
	},
	data() {
		return {
      navList:[{
        id: 1,
        title: '企业信息'
      },{
        id: 2,
        title: '金融产品'
      },{
        id: 3,
        title: '融资需求'
      }],
      current: 1
		};
	},
	created() {

	},
	methods: {
    navClick(id){
      this.current = id
    }
	},
};
</script>

<style scoped lang="scss">
.check {
  height: 100%;
  width: 100%;
  .nav {
    display: flex;
    align-items: center;
    p {
      width: 120px;
      line-height: 44px;
      text-align: center;
      border: 1px solid rgb(98, 58, 162);
    }
    .active {
      color: #fff;
      background: rgb(98, 58, 162);
    }
  }
}
</style>
